import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-225c3d22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ncgr-section ncgr-section--grouped-background ncgr-section--short ncgr-pad-t-24" }
const _hoisted_2 = { class: "ncgr-container -size-m -is-gapless" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"ncgr-sequence ncgr-mar-b-24\" data-v-225c3d22><ul class=\"ncgr-sequence__items\" data-v-225c3d22><li class=\"ncgr-sequence__item ncgr-sequence__item--active\" data-v-225c3d22> 入力 </li><li class=\"ncgr-sequence__item ncgr-sequence__item--active\" data-v-225c3d22> 確認 </li><li class=\"ncgr-sequence__item ncgr-sequence__item--active\" data-v-225c3d22> 完了 </li></ul></div>", 1)
const _hoisted_4 = {
  key: 0,
  class: "ncgr-card ncgr-card--rounded-to-normal ncgr-pad-16 ncgr-align-center ncgr-mar-b-16"
}
const _hoisted_5 = { class: "ncgr-typography-small ncgr-typography-secondary-label" }
const _hoisted_6 = { class: "ncgr-heading -size-m" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ご入力いただいたメールアドレスに予約確認メールを送信しました。 ", -1))
const _hoisted_8 = {
  key: 1,
  class: "ncgr-card ncgr-card--rounded-to-normal ncgr-pad-16"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "ncgr-heading -size-m ncgr-mar-b-16 ncgr-align-center" }, " Xにポストしたら作った人が喜ぶかも👾 ", -1))
const _hoisted_10 = { class: "tweet-card__image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "tweet-card__info" }
const _hoisted_13 = { class: "ncgr-heading -size-s" }
const _hoisted_14 = { class: "ncgr-typography-secondary-label ncgr-typography-small ncgr-typography-bold" }
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_leading" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "ncgr-icon",
    "data-icon": "x"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "_body" }, " ポストする ", -1))
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SuzuriHeader = _resolveComponent("SuzuriHeader")!
  const _directive_track = _resolveDirective("track")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_SuzuriHeader),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.order)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, " 予約番号：" + _toDisplayString(_ctx.order.id), 1),
              _createElementVNode("h1", _hoisted_6, _toDisplayString(_ctx.messageHeading), 1),
              _hoisted_7
            ]))
          : _createCommentVNode("", true),
        (_ctx.campaign && !_ctx.campaign.sample)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderDetails, (orderDetail) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: orderDetail.id,
                  class: "tweet-card"
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      class: "ncgr-image",
                      src: _ctx.variantThumbnail(orderDetail.variant)
                    }, null, 8, _hoisted_11)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.campaign.name), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t(`item-name.${_ctx.campaign.item.name}.short`)), 1),
                    _createElementVNode("p", null, _toDisplayString(_ctx.formatPrice(orderDetail.variant.priceWithTax)), 1),
                    _withDirectives((_openBlock(), _createElementBlock("a", {
                      class: "ncgr-x-button",
                      href: _ctx.tweetUrl,
                      rel: "noopener",
                      target: "_blank"
                    }, _hoisted_18, 8, _hoisted_15)), [
                      [_directive_track, void 0, "orders_share-twitter"]
                    ])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}